module.exports = __webpack_public_path__ + "static/media/BiSharesLogo.cabd32fa.png";